import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS = '[VeranstaltungenModul] PostQueryFunkprotokollMandantOptions laden';
export const POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS_AUSFUEHREN = '[VeranstaltungenModul] PostQueryFunkprotokollMandantOptions ausführen';
export const POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS_ERFOLGREICH = '[VeranstaltungenModul] PostQueryFunkprotokollMandantOptions laden erfolgreich';
export const POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS_FEHLER = '[VeranstaltungenModul] PostQueryFunkprotokollMandantOptions Ladefehler';
export const POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostQueryFunkprotokollMandantOptions nicht ausgeführt (evtl. Offline)';


export class PostQueryFunkprotokollMandantOptionsAction implements Action {
    readonly type = POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS;
        constructor(public optPayload: any = null) {}
    }
export class PostQueryFunkprotokollMandantOptionsAusfuehrenAction implements Action {
    readonly type = POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class PostQueryFunkprotokollMandantOptionsErfolgreichAction implements Action {
    readonly type = POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS_ERFOLGREICH;
        constructor(public payload: api.FunkprotokollMandantOptions, public optPayload: any = null) {}
    }
export class PostQueryFunkprotokollMandantOptionsFehlerAction implements Action {
    readonly type = POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class PostQueryFunkprotokollMandantOptionsNichtAusgefuehrtAction implements Action {
    readonly type = POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandQueryFunkprotokollMandantOptionsActions =
    PostQueryFunkprotokollMandantOptionsAction
    | PostQueryFunkprotokollMandantOptionsAusfuehrenAction
    | PostQueryFunkprotokollMandantOptionsErfolgreichAction
    | PostQueryFunkprotokollMandantOptionsFehlerAction
    | PostQueryFunkprotokollMandantOptionsNichtAusgefuehrtAction
    ;
